import { PAGE_URL } from 'constants/page_url'

export const DEFAULT_ROUTES = Object.freeze({
  SITE_CONCIERGE: `/${PAGE_URL.SITE_CONCIERGE}`,
  INTELLIGENT_SEARCH: `/${PAGE_URL.INTELLIGENT_SEARCH}`,
  AI_PERFORMANCE_OVERVIEW: `/${PAGE_URL.AI_PERFORMANCE_OVERVIEW}`,
  AI_CONVERSATION_INSIGHTS: `/${PAGE_URL.AI_CONVERSATION_INSIGHTS}`,
  PLAYBOOKS: `/${PAGE_URL.PLAYBOOKS}`,
  EMAIL_CAMPAIGNS: `/${PAGE_URL.EMAIL_CAMPAIGNS}`,
  CHAT_PLAYBOOKS: `/${PAGE_URL.CHAT_PLAYBOOKS}`,
  FASTLANE_PLAYBOOKS: `/${PAGE_URL.FASTLANE_PLAYBOOKS}`,
  SALES_RESULTS: `/${PAGE_URL.SALES_RESULTS}`,
  CONVERSATIONS: `/${PAGE_URL.CONVERSATIONS}`,
  MEETINGS: `/${PAGE_URL.MEETINGS}`,
  CALLS: `/${PAGE_URL.CALLS}`,
  REVENUE_OVERVIEW: `/${PAGE_URL.REVENUE_OVERVIEW}`,
  REVENUE_OPPORTUNITIES: `/${PAGE_URL.REVENUE_OPPORTUNITIES}`,
  EMAIL_PLAYBOOKS: `/${PAGE_URL.EMAIL_PLAYBOOKS}`,
  CONVO_ANALYSIS: `/${PAGE_URL.CONVO_ANALYSIS}`,
  TEAM_PERFORMANCE: `/${PAGE_URL.TEAM_PERFORMANCE}`,
  TEAM_AVAILABILITY: `/${PAGE_URL.TEAM_AVAILABILITY}`,
  ROUTING: `/${PAGE_URL.ROUTING}`,
  SERVICE: `/${PAGE_URL.SERVICE}`,
  REAL_TIME: `/${PAGE_URL.REAL_TIME}`,
  CONVO_DETAIL: `/${PAGE_URL.CONVO_DETAIL}`,
})
